const Backbone = require('backbone');
const FinishModel = require('app/models/store/client/product/finish');
const finishClickedEvent = 'finish:clicked';

var FinishView = Backbone.View.extend({
	model: FinishModel,

	events: {
		click: 'updatePage',
		'mouseenter .js-finish-swatch': '_hoverStart',
		'mouseleave .js-finish-swatch': '_hoverEnd'
	},

	initialize: function(options = {}) {
		this.options = options;
		// Preload image?
		let img = new Image();
		img.src = this.model.get('images')[50];
		// We listen to this event here so this happens across all finish views
		this.listenTo(Backbone, finishClickedEvent, this.render);

		this.$('[type=radio]').prop('disabled', false);

		if (window.BCOM.device.isMobile) {
			delete this.events.click;
			this.events['click .js-finish-thumb'] = 'updatePage';
			this.events['click .js-select-button'] = 'updatePage';
			this.events['click img'] = '_openGallery';
			this.delegateEvents();
		}
		this.$textProductLink = $('.js-social-text');
	},

	_hoverStart: function(event) {
		if (window.BCOM.device.isDesktop) {
			this.model.set('index', $(event.currentTarget).data('iterator'));
			this.model.set('hovered', true, { silent: true });
			Backbone.trigger('finish:hover', this.model.toJSON());
		}
	},

	_hoverEnd: function() {
		if (window.BCOM.device.isDesktop) {
			var productModel = this.options.options.parentView.model,
				finishCollection = this.options.options.parentView.childViews.finishesView.collection,
				selected = finishCollection.find((finish) => {
					return finish.get('selected');
				});

			if (selected) {
				selected.set('index', finishCollection.indexOf(selected));
				selected = selected.toJSON();
			} else {
				selected = productModel.get('defaults');
				selected.isDefault = true;
				selected.index = 0;
			}
			this.model.set('hovered', false, { silent: true });
			Backbone.trigger('finish:hover', selected);
		}
	},
	_openGallery: function() {
		const mediaGallery = this.options.pageView.childViews.mediaGallery;
		const modal = mediaGallery.$el.find('.js-modal-media-gallery');
		if (modal.length) {
			modal.addClass('single-finish');
			mediaGallery.currentIndex = this.$el.data('iterator');
			mediaGallery.setGalleryImage();
			mediaGallery.launchMediaGalleryModal();
		}
	},

	/**
	 * When a user clicks a finish this function sends a message with with the
	 * clicked finishes information and checks the corresponding radio button.
	 * @param  {Object} e The click event
	 */
	updatePage: function(event) {
		event.preventDefault();
		if (this.model.get('isPaint') && this.model.get('status').toLowerCase() === 'nonstock') {
			return;
		}
		const clickedFinishIsAlreadySelected = this.model.isSelected();
		let $compareButton = $('.js-compare-toggle-btn');
		this.model.set('index', $(event.currentTarget).data('iterator'));
		Backbone.trigger(finishClickedEvent, this.model.toJSON());
		Backbone.trigger('omniture:finishselected', this.model.toJSON());
		this.$('[type=radio]').prop('checked', true);
		this.updateHistory();
		this.options.pageView.saveLastProductUrl(this.model.get('productLink'));
		if (window.dataLayer.isPla) {
			$('.js-finish-pla-popover').popover('hide');
		}
		if (this.$textProductLink) {
			this.$textProductLink.attr('href', `/sms-product?puid=${this.model.get('uniqueId')}`);
		}
		if ($compareButton.length) {
			Backbone.trigger('compare:changeFinish', $compareButton.attr('value'), this.model.get('uniqueId'));
		}

		Backbone.trigger('PLAfinish:selected', this.model.toJSON());
		Backbone.trigger('finishmenu:toggle');

		if (!clickedFinishIsAlreadySelected) {
			const uniqueId = this.model.get('uniqueId');
			const newProductUrl = this.generateNewUrl(uniqueId);
			window.BCOM.util.trackProductFinishChange(uniqueId, newProductUrl);
		}

		if (this.model.get('sku')) {
			$('#heading').text(`${this.model.get('sku')}`);
		} else if (this.model.get('productId')) {
			$('#heading').text(`${this.model.get('productId')}`);
		}
	},
	generateNewUrl: function(uid) {
		const { pathname: path, href } = window.location;
		const sPagePattern = /\/s[0-9]+$/;
		const fpPagePattern = /\/[pf]([0-9]+)$/; // work with f-codes and p-codes
		let newUrl = href;
		if (sPagePattern.test(path)) {
			newUrl = window.BCOM.util.updateURLParameters(href, 'uid', uid);
		} else if (fpPagePattern.test(path)) {
			const oldUid = path.match(fpPagePattern)[1];
			newUrl = href.replace(oldUid, uid);
		}
		return newUrl;
	},
	updateHistory: function() {
		const uid = this.model.get('uniqueId');

		const hasPinterestShareButton = $('.js-socialbar-pinterest').length;

		if (hasPinterestShareButton) {
			this.updatePinterestURL(uid);
		}

		if (history.replaceState && uid) {
			history.replaceState({}, '', this.generateNewUrl(uid));
		}
	},

	updatePinterestURL: function(uid) {
		const $pinterestButton = $('.js-socialbar-pinterest');

		// Get the initial product url from the pinterest button and update the UID
		const initialPinterestUrl = $pinterestButton.data('link');
		let updatedPinterestLink;

		updatedPinterestLink = this._updatePinterestUid(initialPinterestUrl, uid);
		updatedPinterestLink = this._updatePinterestMedia(updatedPinterestLink);
		updatedPinterestLink = this._updatePinterestDescription(updatedPinterestLink);

		// Update the button's data-link
		$pinterestButton.data('link', updatedPinterestLink);
	},

	_updatePinterestUid(url, uid) {
		const initialProductUrl = this._getPinterestUrl(url);
		const updatedProductUrl = window.BCOM.util.updateURLParameters(initialProductUrl, 'uid', uid);
		const updatedUidPinterestUrl = window.BCOM.util.updateURLParameters(url, 'url', updatedProductUrl);
		return updatedUidPinterestUrl;
	},

	_updatePinterestMedia(url) {
		const media = this._getPinterestImage();
		return window.BCOM.util.updateURLParameters(url, 'media', media);
	},

	_updatePinterestDescription(url) {
		const description = this._getPinterestDescription();
		return window.BCOM.util.updateURLParameters(url, 'description', description);
	},

	_getPinterestUrl(url) {
		return window.BCOM.util.getQueryStringParameter('url', url);
	},

	_getPinterestImage() {
		return this.model.get('images')[450].replace('https:', '');
	},

	_getPinterestDescription() {
		return `${this.model.get('name')} ${this.model.get('title')}`;
	},

	render: function() {
		var $el = this.$el.find('[class*=js-finish-]');
		$el.toggleClass('b--theme-grey-dark', this.model.isSelected());
		$el.toggleClass('b--theme-grey', !this.model.isSelected());
		if (window.BCOM.device.isMobile) {
			this.options.pageView.childViews.purchase.hideError();
			this._showStatus();
		}
	},

	_showStatus: function() {
		const $selectButton = this.$('.js-select-button');
		if (this.model.isSelected()) {
			$selectButton.text('Selected');
			this.$el.toggleClass('not-available', false);
		} else if (this.model.get('isPaint') && this.model.get('status').toLowerCase() === 'nonstock') {
			$selectButton.text('Unavailable');
			this.$el.toggleClass('not-available', true);
		} else {
			$selectButton.text('Select');
			this.$el.toggleClass('not-available', false);
		}
	}
});

module.exports = FinishView;
